<template>
    <span class="partner-icon" :class="classes">
        <SvgIcon
            v-if="icon === 'clock'"
            width="24px"
            height="24px"
            icon="clock"
        />
        <SvgIcon
            v-if="icon === 'tag'"
            width="24px"
            height="24px"
            icon="tag"
        />
        <SvgIcon
            v-if="icon === 'price'"
            width="24px"
            height="24px"
            icon="price"
        />
        <SvgIcon
            v-if="icon === 'discount'"
            width="24px"
            height="24px"
            icon="discount"
        />
        <SvgIcon
            v-if="icon === 'address'"
            width="24px"
            height="24px"
            icon="address"
        />
        <SvgIcon
            v-if="icon === 'phone'"
            width="18px"
            height="18px"
            icon="phone"
        />
        <SvgIcon v-if="icon === 'qr'" width="21px" height="20px" icon="qr" />
        <span v-else></span>
    </span>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "PartnerIcons",
    components: { SvgIcon },
    props: ["icon", "classes"]
};
</script>
